import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-dependency',
  templateUrl: './card-dependency.component.html',
  styleUrls: ['./card-dependency.component.css']
})
export class CardDependencyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
